.BaseEditor p::before {
  content: attr(data-placeholder);
  float: left;
  color: rgba(0, 0, 0, 0.4);
  pointer-events: none;
  height: 0;
}
